



















































































































import { Prop, Component, Vue, Ref } from "vue-property-decorator";
import EditableTableCell from "../components/coordinate/editable-table-cell.vue";
import { UIModel } from "../UIModel";
import _ from 'lodash';
import { SortOrder } from '@/util/PaginationParameters';
import * as moment from "moment";
import RequestAccessModal from "../components/projectlist/request_access_modal.vue";
import ProjectUsersImportModal from "../components/projectlist/project_users_import_modal.vue";
import { EPlatform } from "@/model/EPlatform";

@Component({
    components: { 
        EditableTableCell, 
        RequestAccessModal,
        ProjectUsersImportModal 
    },
    filters: {
        // TODO: Refactor filter into a shared utility file
        uppercase: function(value: string) {
            if (!value) return ''
            value = value.toString();
            return value.toUpperCase();
        },
        capitalize(value: string) {
            if (!value) return '';
            return value
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        }
    }
})

export default class ProjectList extends Vue {

    @Prop({ required: true }) public model!: UIModel;

    @Ref() public requestAccessModal!: RequestAccessModal;

    @Ref() public accProjectUsersImportModal!: ProjectUsersImportModal;

    get projectListData(): any[] {
        return this.model.accProjects.data;
	}

    get statusOptions() {
			return [
				{ name: "Show All Status", value: "" },
				{ name: "Active", value: "active" },
				{ name: "Archived", value: "archived" },
                { name: "Pending", value: "pending" },
                { name: "Suspended", value: "suspended" }
			]
    }

    get platformOptions() {
			return [
				{ name: "Show All Platforms", value: "" },
				{ name: "Forma", value: "acc" },
				{ name: "BIM360", value: "bim360" }
			]
    }

    get searchOptions() {
        return [
            { name: "Search By", value: "" },
            { name: "Name", value: "name" },
            { name: "Number", value: "jobNumber" }
        ];
    }

    public created () {
        this.model.getUserProjects();
        this.model.initProjectListModule();
    }


    public async changePage(page: number): Promise<void> {
        await this.model.accProjects.changePage(page - 1);
        // this.sortedPage = JSON.parse(JSON.stringify(this.model.projectIssues.data));
	}

    public sortProjects(field: string, order: SortOrder): void {
        console.log(field, order);
        this.model.accProjects.setSorting(field, order);
    }

    formatDate(date: string) {
        if (date) {
            return moment.default(date).format("DD/MM/YYYY");
        } else {
            return "-";
        }
	}

    public async filterByStatus(value: any) {
			// this.model.issueCheckedRows = [];
			// console.log("Filter by status");
			// this.sortBehavior = 'Sort Page';
			// this.model.refreshIssuesData();
	}

    public async filterByPlatform(value: any) {

    }

    public openRequestAccessModal(name: string, projectID: string, platform: EPlatform) {
		this.requestAccessModal.open({ projectName : name, projectID: projectID, platform: platform });
	}

    public hasAccess(projectID: string): boolean {
        const found = this.model.userProjects.find(p => p.id == projectID);
        if(found) return true;
        return false;
    }

    public openProjectUsersModal(projectType: "ACC" | "BIM360"): void {
        if(projectType == "ACC") {
            this.accProjectUsersImportModal.open();   
        }
    }

    public displayPlatform(platform: string) {
        if (platform === 'acc') {
            return 'Forma';
        }

        return platform ? platform.toUpperCase() : '';
    }
}
